var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdviserChannelPage',{attrs:{"channel":_vm.channel}})
}
var staticRenderFns = []

export { render, staticRenderFns }